import { HourSubheading } from "../../typings";

export const getDailyHours = (startHours: number = 0): HourSubheading[] => {
    const dailyHours: HourSubheading[] = [];
    for (startHours; startHours < 24; startHours++) {
        dailyHours.push({
            id: startHours.toString(),
            name: `${("0" + startHours).slice(-2)}:00`
        });
    }
    return dailyHours;
}